"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFittingCameraFromPoints = void 0;
var maputil_1 = require("@/transformers/maputil");
var getBoundsZoomLevel = function (ne, sw, width, height) {
    var WORLD_DIM = { height: 256, width: 256 };
    var ZOOM_MAX = 21;
    var latRad = function (lat) {
        var sin = Math.sin(lat * Math.PI / 180);
        var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
        return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
    };
    var zoom = function (mapPx, worldPx, fraction) {
        return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
    };
    var latFraction = (latRad(ne.lat) - latRad(sw.lat)) / Math.PI;
    var lngDiff = ne.lng - sw.lng;
    var lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;
    var latZoom = zoom(height, WORLD_DIM.height, latFraction);
    var lngZoom = zoom(width, WORLD_DIM.width, lngFraction);
    return Math.min(latZoom, lngZoom, ZOOM_MAX);
};
var getBound = function (points) {
    var maxLat = Math.max.apply(Math, points.map(function (it) { return it.lat; }));
    var minLat = Math.min.apply(Math, points.map(function (it) { return it.lat; }));
    var maxLng = Math.max.apply(Math, points.map(function (it) { return it.lng; }));
    var minLng = Math.min.apply(Math, points.map(function (it) { return it.lng; }));
    return {
        ne: { lat: maxLat, lng: maxLng },
        sw: { lat: minLat, lng: minLng },
    };
};
exports.getFittingCameraFromPoints = function (points, width, height) {
    var _a = getBound(points), ne = _a.ne, sw = _a.sw;
    var center = maputil_1.getCenterFromNeSw(ne, sw);
    var zoom = getBoundsZoomLevel(ne, sw, width, height);
    return { center: center, zoom: zoom };
};
